import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import * as NumberUtils from '@/utils/NumberUtils'

/**
 * 海运出口工具类
 */
export class SeaExportUtils {
  // static formatter = new NumberFormatter()
  /**
   * HBL并且操作
   */
  static jointJobsHBL(model, cargoDoc, selectedJobs) {
    model.joinFlagHBL = true
    // 定义一个函数，用于处理数值的校验和转换
    function validateAndConvert(value) {
      if (isNaN(value) || !value) {
        return 0
      }
      return Number(value)
    }
    for (const job of selectedJobs) {
      if (job.joinFlagHBL && model.jointSlavesHBL.findIndex(p => p.uuid === job.uuid) > -1) {
        continue
      }
      // 件数
      const quantity = validateAndConvert(job.quantityActual)
      const quantityDoc = validateAndConvert(cargoDoc.quantity)

      // 重量
      const weight = validateAndConvert(job.weightActual)
      const weightDoc = validateAndConvert(cargoDoc.weight)

      // 体积
      const cubage = validateAndConvert(job.cubageActual)
      const cubageDoc = validateAndConvert(cargoDoc.cubage)

      // 更新 cargoDoc 的值
      cargoDoc.quantity = NumberUtils.ToFixed2(quantityDoc + quantity, 2)
      cargoDoc.weight = NumberUtils.ToFixed2(weightDoc + weight, 3)
      cargoDoc.cubage = NumberUtils.ToFixed2(cubageDoc + cubage, 3)
    }
  }
  /**
   * MBL并单操作
   */
  static jointJobsMBL(model, cargoDoc, selectedJobs) {
    model.joinFlagMBL = true
    // 定义一个函数，用于处理数值的校验和转换
    function validateAndConvert(value) {
      if (isNaN(value) || !value) {
        return 0
      }
      return Number(value)
    }

    for (const job of selectedJobs) {
      if (job.joinFlagMBL && model.jointSlavesMBL.findIndex(p => p.uuid === job.uuid) > -1) {
        continue
      }
      // 件数
      const quantity = validateAndConvert(job.quantityActual)
      const quantityDoc = validateAndConvert(cargoDoc.quantity)

      // 重量
      const weight = validateAndConvert(job.weightActual)
      const weightDoc = validateAndConvert(cargoDoc.weight)

      // 体积
      const cubage = validateAndConvert(job.cubageActual)
      const cubageDoc = validateAndConvert(cargoDoc.cubage)

      // 更新 cargoDoc 的值
      cargoDoc.quantity = NumberUtils.ToFixed2(quantityDoc + quantity, 2)
      cargoDoc.weight = NumberUtils.ToFixed2(weightDoc + weight, 3)
      cargoDoc.cubage = NumberUtils.ToFixed2(cubageDoc + cubage, 3)
    }
  }
  /**
   * HAWB2并单操作
   */
  static jointJobsHAWB2(model, cargoDoc, selectedJobs) {
    model.joinFlagHAWB2 = true
    // 定义一个函数，用于处理数值的校验和转换
    function validateAndConvert(value) {
      if (isNaN(value) || !value) {
        return 0
      }
      return Number(value)
    }
    for (const job of selectedJobs) {
      if (job.joinFlagHAWB2 && model.jointSlavesHAWB2.findIndex(p => p.uuid === job.uuid) > -1) {
        continue
      }

      // 件数
      const quantity = validateAndConvert(job.quantityActual)
      const quantityDoc = validateAndConvert(cargoDoc.quantity)
      // 小件件数
      const insideQuantity = validateAndConvert(job.insideQuantity)
      const insideQuantityDoc = validateAndConvert(cargoDoc.insideQuantity)
      // 重量
      const weight = validateAndConvert(job.weightActual)
      const weightDoc = validateAndConvert(cargoDoc.weight)
      // 体积
      const cubage = validateAndConvert(job.cubageActual)
      const cubageDoc = validateAndConvert(cargoDoc.cubage)
      // 件数
      cargoDoc.quantity = NumberUtils.ToFixed2(quantityDoc + quantity, 2)
      // 小件件数
      cargoDoc.insideQuantity = NumberUtils.ToFixed2(insideQuantityDoc + insideQuantity, 2)
      // 重量
      cargoDoc.weight = NumberUtils.ToFixed2(weightDoc + weight, 3)
      // 体积
      cargoDoc.cubage = NumberUtils.ToFixed2(cubageDoc + cubage, 3)
    }
  }
  /**
   * MSC并单操作
   */
  static jointJobsMSC(model, cargoDoc, selectedJobs) {
    // for each(var job in selectedJobs)
    // {
    //   if (job.isJoinFlagMBL)
    //     continue
    //   job.jointMasterMBL = model
    //   job.isJoinFlagMBL = true
    //   //件数
    //   model.quantityActual = model.quantityActual + job.quantityActual
    //   //重量
    //   model.weightActual = model.weightActual + job.weightActual
    //   //体积
    //   model.cubageActual = model.cubageActual + job.cubageActual
    // }
  }
  /**
   * 并单，拼接英文品名，箱型，箱量信息。
       * 直接根据当且HBL并单拆单/MBL并单拆单里的提单重量和体积计算收费重量
   */
  static jointSeqContainerInfo(seaeqTxt, containerTxt, model, cargoDoc, selectedJobs, txtChargeWeight) {
    let cargoEName = ''
    let cargoENameNew = ''
    let seaeq = ''
    let container = ''
    let mark = ''
    for (const job of selectedJobs) {
      if (cargoEName) {
        cargoEName += '\n'
      }
      if (job.cargoEnglishName) {
        cargoEName += job.cargoEnglishName
      }
      if (seaeq) {
        seaeq += '\n'
      }
      seaeq += this.getSeaeqDesc(job)
      if (container) {
        container += '\n'
      }
      container += this.getContainerDesc(job)
      if (cargoDoc.cargoEnglishName !== job.cargoEnglishName) {
        if (cargoENameNew) {
          cargoENameNew += '\n'
        }
        cargoENameNew += job.cargoEnglishName
      }
      if (mark) {
        mark += '\n'
      }
      if (job.mark) {
        mark += job.mark
      }
    }
    txtChargeWeight = this.calcChargeWeight(cargoDoc.weight, cargoDoc.cubage)
    if (cargoENameNew || cargoDoc.cargoEnglishName) {
      if (cargoDoc.cargoEnglishName) {
        cargoENameNew = cargoDoc.cargoEnglishName + '\n' + cargoENameNew
      }
    }
    if (cargoEName) {
      if (cargoDoc.cargoEnglishName) {
        cargoDoc.cargoEnglishName += '\n'
      } else if (model.cargoEnglishName) {
        cargoDoc.cargoEnglishName = model.cargoEnglishName + '\n'
      }
      cargoDoc.cargoEnglishName += cargoEName
    }
    if (seaeq) {
      seaeqTxt += '\n' + seaeq
    }
    if (container) {
      containerTxt += '\n' + container
    }
    return {
      cargoEnglishName: cargoEName,
      seaeq: seaeqTxt,
      container: containerTxt,
      chargeWeight: txtChargeWeight,
      cargoEnglishName2: cargoENameNew,
      mark: mark
    }
  }
  static jointMscSeqContainerInfo(model, cargoDoc, selectedJobs) {
    // var cargoDocEdiContainersCollection = cargoDoc.ediContainer
    // if (cargoDocEdiContainers == null) {
    //   cargoDocEdiContainers = new ArrayCollection()
    //   cargoDoc.ediContainer = cargoDocEdiContainers
    // }
    // for each(var job in selectedJobs)
    // {
    //   //合并seaEq
    //   for each(var seaEq in job.seaEQ)
    //   {
    //     var isExistSameSizeType = false
    //     for each(var modelSeaEq in model.seaEQ)
    //     {
    //       if (modelSeaEq.EQsize == seaEq.EQsize && modelSeaEq.EQtype == seaEq.EQtype) {
    //         isExistSameSizeType = true
    //         modelSeaEq.EQquantity += seaEq.EQquantity
    //       }
    //     }
    //     //如果原SeaExportJob中没找到和seaEq箱型箱种相同的，则新增一个
    //     if (!isExistSameSizeType) {
    //       var seaEQ = new SeaEQ()
    //       seaEQ.job = model
    //       seaEQ.EQsize = seaEq.EQsize
    //       seaEQ.EQtype = seaEq.EQtype
    //       seaEQ.EQquantity = seaEq.EQquantity
    //     }
    //   }
    //   //合并EdiContainer
    //   //1.并入所有的containerUsage信息 2.被并单的job有几个msc装箱信息就把这些装箱信息
    //   //连同其所属的货物信息一同加到原job中的msc箱货信息中
    //   for each(var oldUsage in job.containerUsages)
    //   {
    //     var oldUsageEdiContainer: EDIContainer = oldUsage.ediContainer
    //     var newUsage = oldUsage.copyMscContainerUsage()
    //     newUsage.job = model
    //     newUsage.container.job = model
    //     if (oldUsageEdiContainer && oldUsageEdiContainer.mscCargoDoc) {
    //       newUsage.ediContainer.mscCargoDoc = cargoDoc
    //       //如果被并单的msc装箱中有货物,则带入货物
    //       var oldEdiContainerPoItemsCollection = oldUsageEdiContainer.poItems
    //       if (oldEdiContainerPoItems && oldEdiContainerPoItems.length > 0) {
    //         for each(var item: PoItems in oldEdiContainerPoItems)
    //         {
    //           var newPoitems: PoItems = item.copyMscPoitems()
    //           newPoitems.ediContainer = newUsage.ediContainer
    //         }
    //       }
    //     }
    //   }
    // }
  }
  static jointSeqContainer(j, selectedJobs) {
    // var result = []
    // var container = ''
    // var source = selectedJobs
    // //			source.push(j)
    // for each(var job in source)
    // {
    //   for each(var c in job.containerUsages)
    //   {
    //     if (eContainerUsageExits(result, c)) {
    //       result.push(c)
    //     }
    //   }
    // }
    // for each(var cu in result)
    // {
    //   if (container.length > 0)
    //     container += '\n'
    //   container += cu.container.containerNo + ' / ' + cu.container.sealNo + ' / ' + (cu.container.EQsize + cu.container.EQtype) //箱封信息
    // }
    // return container
  }
  /**
   *判断是否有相同的封箱信息
   */
  static eContainerUsageExits(result, cn) {
    // for each(var cu in result)
    // {
    //   if (cu.container.EQsize == cn.container.EQsize && cu.container.EQtype == cn.container.EQtype && cu.container.containerNo == cn.container.containerNo && cu.container.sealNo == cn.container.sealNo) {
    //     return false
    //   }
    // }
    // return true
  }
  /**
   * 拼单箱量拼接
   */
  static mergeJobSeaEq(j, selectedJobs) {
    // var result = []
    // var desc = ''
    // var source = selectedJobs
    // source.push(j)
    // for each(var job in source)
    // {
    //   for each(var seq in job.seaEQ)
    //   {
    //     if (eQquantityExits(result, seq)) {
    //       var q = new SeaEQ()
    //       q.EQquantity = seq.EQquantity
    //       q.EQsize = seq.EQsize
    //       q.EQtype = seq.EQtype
    //       result.push(q)
    //     }
    //   }
    // }
    // for each(var eq in result)
    // {
    //   if (desc.length > 0) {
    //     desc += '\n'
    //   }
    //   desc += eq.EQquantity + ' * ' + eq.EQsize + ' ' + eq.EQtype
    // }
    // return desc
  }
  static eQquantityExits(result, seq) {
    // for each(var s in result)
    // {
    //   if (s.EQsize == seq.EQsize && s.EQtype == seq.EQtype) {
    //     s.EQquantity += seq.EQquantity
    //     return false
    //   }
    // }
    // return true
  }
  /**
   * 刷新HBL,MBL箱封信息
   */
  static refreshCargoDocContainer(job) {
    // if (job.needLoadCargoDoc())
    //   return
    // for each(var doc in job.cargoDoc)
    // {
    //   if (doc.docType == CargoDocConsts.HBL || doc.docType == CargoDocConsts.MBL) {
    //     doc.container = getContainerDesc(job, doc.isPrintParam3)
    //   }
    // }
  }
  static getSeaeqDesc(job, printParam1 = false, portOf = 'Part of') {
    let desc = ''
    if (job.lob === 'SE') {
      const seajob = job
      if (seajob.containerLoadType === 'BB') {
        desc = 'LCL'
      } else if (seajob.containerLoadType === 'LCL') {
        if (printParam1) {
          for (const cu of seajob.containerUsages) {
            if (desc) {
              desc += '\n'
            }
            desc += portOf.toUpperCase() + ' ' + cu.container.eqSize + ' ' + cu.container.eqType
          }
        } else {
          desc = 'LCL'
        }
      } else if (seajob.containerLoadType === 'FCL') {
        for (const seq of seajob.seaEQ) {
          if (desc.length > 0) {
            desc += '\n'
          }
          if (printParam1) {
            desc += portOf.toUpperCase() + ' ' + seq.eqSize + ' ' + seq.eqType
          } else {
            desc += seq.eqQuantity + ' * ' + seq.eqSize + ' ' + seq.eqType
          }
        }
      }
    }
    if (job.lob === 'SI') {
      const seaImjob = job
      if (seaImjob.containerLoadType === 'BB') {
        desc = 'LCL'
      } else if (seaImjob.containerLoadType === 'LCL') {
        if (printParam1) {
          for (const usage of seaImjob.containerUsages) {
            if (desc) {
              desc += '\n'
            }
            desc += portOf.toUpperCase() + ' ' + usage.container.eqSize + ' ' + usage.container.eqType
          }
        } else {
          desc = 'LCL'
        }
      } else if (seaImjob.containerLoadType === 'FCL') {
        for (const seaImSeq of seaImjob.seaEQ) {
          if (desc) {
            desc += '\n'
          }
          if (printParam1) {
            desc += portOf.toUpperCase() + ' ' + seaImSeq.eqSize + ' ' + seaImSeq.eqType
          } else {
            desc += seaImSeq.eqQuantity + ' * ' + seaImSeq.eqSize + ' ' + seaImSeq.eqType
          }
        }
      }
    }
    return desc
  }
  static getContainerDesc(job, printParam3 = false) {
    if (!job.containerUsages || job.containerUsages.length <= 0) return ''
    let desc = ''
    for (const cu of job.containerUsages) {
      if (!cu || !cu.container) continue
      if (desc) {
        desc += '\n'
      }
      if (printParam3) {
        desc += cu.container.containerNo + ' / ' + cu.container.sealNo + ' / ' + cu.quantity + ' / ' + cu.weight.toFixed(2) + ' / ' + cu.cubage.toFixed(3)
      } else {
        desc += cu.container.containerNo + ' / ' + cu.container.sealNo + ' / ' + (cu.container.eqSize + cu.container.eqType)
      } // 箱封信息
    }
    return desc
  }
  /**
   * 获取主票与小票的不同字段
   */
  static getDiffFields(lclMaster, job) {
    const fields = []
    if (job.vessel !== lclMaster.vessel) { fields.push('船名') }
    if (job.voyageFlight !== lclMaster.voyageFlight) { fields.push('航次') }
    if (job.bookingAgent !== lclMaster.bookingAgent) { fields.push('订舱代理') }
    if (job.carrierId !== lclMaster.carrierId) { fields.push('船公司') }
    if (job.destinationAgent !== lclMaster.destinationAgent) { fields.push('目的港代理') }
    if (job.paymentTermMBL !== lclMaster.paymentTermMBL) { fields.push('主单运费条款') }
    return fields
  }
  static getJoinSeaDocSeaEQDesc(doc, job, printParam1 = false, portOf = 'Part of') {
    if (!doc || !job) return
    let ediContainer
    let result = ''
    const ediItem = {}
    if (job.containerLoadType === 'BB') {
      result = 'LCL'
    } else if (job.containerLoadType === 'LCL') {
      if (printParam1) {
        for (ediContainer of doc.ediContainer) {
          if (ediContainer.deleted) continue
          if (result.length > 0) {
            result += '\n'
          }
          result += portOf.toUpperCase() + ' ' + ediContainer.eqSize + ' ' + ediContainer.eqType
        }
      } else {
        result = 'LCL'
      }
    } else if (job.containerLoadType === 'FCL') {
      for (ediContainer of doc.ediContainer) {
        if (ediContainer.deleted) continue
        const key = ediContainer.eqSize + ediContainer.eqType
        if (!ediItem.hasOwnProperty(key)) {
          ediItem[key] = 1
        } else {
          ediItem[key] = ediItem[key] + 1
        }
      }
      for (const k in ediItem) {
        if (result.length > 0) {
          result += '\n'
        }
        if (printParam1) {
          result += (portOf.toUpperCase() + ' ' + ediItem[k] + ' ' + k)
        } else {
          result += (ediItem[k] + ' * ' + k)
        }
      }
    }
    return result
  }
  static async getContainerQWCDesc(doc, printParam3 = false) {
    let desc = ''
    const ediContainer = await new SeaCargoDoc(doc).getEdiContainer()
    for (const edi of ediContainer) {
      if (edi.deleted) continue
      if (desc) {
        desc += '\n'
      }
      if (printParam3) {
        const packingList = await getSpecificBasicData(basicCacheKeys.basic_data_Packing)
        const packing = packingList.find(p => p.code === doc.packing)
        const packingName = packing ? packing.name : ''
        desc += edi.containerNo + ' / ' + edi.sealNo + ' / ' + edi.quantity + packingName + ' / ' + Number(edi.weight).toFixed(3) + 'KGS' + ' / ' + Number(edi.cubage).toFixed(3) + 'CBM'
      } else {
        desc += edi.containerNo + ' / ' + edi.sealNo + ' / ' + (edi.eqSize + edi.eqType) // 箱封信息
      }
    }
    return desc
  }
  /**
   * 海运订舱计算计费重量方式
   */
  static calcChargeWeight(weight, cubage) {
    if (isNaN(weight) || isNaN(cubage)) {
      return 0
    }
    weight = weight / 1000
    if (cubage > weight) {
      weight = cubage
    }
    if (weight > 0 && weight < 1) {
      weight = 1.00
    }
    return Number(weight.toFixed(3))
  }
  static customCutoffSortCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.customCutoff
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.customCutoff
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  static crossTenantHistoryStateDateSortCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.crossTenantHistoryStateDate
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.crossTenantHistoryStateDate
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  static fileCutoffSortCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.fileCutoff
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.fileCutoff
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 到港日期
  static fileETACompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.ETA
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.ETA
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 到港日期
  static fileETDCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.ETD
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.ETD
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 创建日期
  static fileDateCreatedCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.dateCreated
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.dateCreated
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 操作日期
  static fileCustomsDateCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.customsDate
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.customsDate
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 实际到港时间
  static fileActualArrivalTimeCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.actualArrivalTime
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.actualArrivalTime
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 送货时间
  static fileDestPortDeliveryTimeCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.destPortDeliveryTime
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.destPortDeliveryTime
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 还箱时间
  static fileDestPortReturnTimeCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.destPortReturnTime
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.destPortReturnTime
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  static terminalOpendateSortCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.terminalOpendate
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.terminalOpendate
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  static terminalCutoffSortCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // if (jobOne != null) {
    //   dateOne = jobOne.terminalCutoff
    // }
    // if (jobTwo != null) {
    //   dateTwo = jobTwo.terminalCutoff
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  static loadingDateSortCompareFunction(obj1, obj2) {
    // if (!obj1 && !obj2)
    //   return 0
    // if (!obj1)
    //   return -1
    // if (!obj2)
    //   return 1
    // var jobOne = obj1 as SeaExportJob
    // var jobTwo = obj2 as SeaExportJob
    // var dateOne = null
    // var dateTwo = null
    // var truckingInfosOneCollection = jobOne.trucking
    // var truckingInfosTwoCollection = jobTwo.trucking
    // if (truckingInfosOne && truckingInfosOne.length > 0) {
    //   var truckingOne: TruckingInfo = truckingInfosOne.getItemAt(0) as TruckingInfo
    //   dateOne = truckingOne.loadingDate
    // }
    // if (truckingInfosTwo && truckingInfosTwo.length > 0) {
    //   var truckingTwo: TruckingInfo = truckingInfosTwo.getItemAt(0) as TruckingInfo
    //   dateTwo = truckingTwo.loadingDate
    // }
    // return dateSortCompareFunction(dateOne, dateTwo)
  }
  // 日期排序函数
  static dateSortCompareFunction(dateOne, dateTwo) {
    // if (!dateOne && !dateTwo) { return 0 }
    // if (!dateOne) { return -1 }
    // if (!dateTwo) { return 1 }
    // return ObjectUtil.dateCompare(dateOne, dateTwo)
  }
}
